import * as THREE from 'three'
import gsap from 'gsap'
import ProjectBoardMaterial from '../../Materials/ProjectBoard.js'
import { loadBoardTexture } from '../../Utils/loadBoardTexture.js'
import { createFloorTexture } from '../../Utils/createFloorTexture.js'

export default class Experience
{
    constructor(_options)
    {
        this.resources = _options.resources
        this.objects = _options.objects
        this.areas = _options.areas
        this.geometries = _options.geometries
        this.meshes = _options.meshes
        this.x = _options.x
        this.y = _options.y
        this.company = _options.company
        this.logo = _options.logo
        this.title = _options.title
        this.period = _options.period
        this.description = _options.description
        this.highlights = _options.highlights

        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        this.setBoard()
        this.setFloor()
        this.setInfoArea()
    }

    setBoard()
    {
        this.board = {}
        this.board.x = this.x
        this.board.y = this.y + 5
        this.board.color = '#8e7161'
        this.board.threeColor = new THREE.Color(this.board.color)

        this.objects.add({
            base: this.resources.items.projectsBoardStructure.scene,
            collision: this.resources.items.projectsBoardCollision.scene,
            floorShadowTexture: this.resources.items.projectsBoardStructureFloorShadowTexture,
            offset: new THREE.Vector3(this.board.x, this.board.y, 0),
            rotation: new THREE.Euler(0, 0, 0),
            duplicated: true,
            mass: 0,
        })

        this.board.planeMesh = this.meshes.boardPlane.clone()
        this.board.planeMesh.position.x = this.board.x
        this.board.planeMesh.position.y = this.board.y
        this.board.planeMesh.matrixAutoUpdate = false
        this.board.planeMesh.updateMatrix()
        this.board.planeMesh.material = new ProjectBoardMaterial()
        this.board.planeMesh.material.uniforms.uColor.value = this.board.threeColor
        this.board.planeMesh.material.uniforms.uTextureAlpha.value = 0
        this.container.add(this.board.planeMesh)

        loadBoardTexture(
            this.logo,
            (texture) =>
            {
                this.board.texture = texture
                this.board.planeMesh.material.uniforms.uTexture.value = this.board.texture
                gsap.to(this.board.planeMesh.material.uniforms.uTextureAlpha, { value: 1, duration: 1, ease: 'power4.inOut' })
            },
            undefined,
            { fallbackLabel: this.company },
        )
    }

    setFloor()
    {
        this.floor = {}
        this.floor.x = 0
        this.floor.y = -2

        this.floor.container = new THREE.Object3D()
        this.floor.container.position.x = this.x + this.floor.x
        this.floor.container.position.y = this.y + this.floor.y
        this.floor.container.matrixAutoUpdate = false
        this.floor.container.updateMatrix()
        this.container.add(this.floor.container)

        this.floor.texture = createFloorTexture({
            title: this.company,
            subtitle: this.title,
            description: this.description,
            meta: [
                { label: 'Period', value: this.period },
                { label: 'Highlights', value: this.highlights.join(' · ') },
            ],
        })
        this.floor.texture.magFilter = THREE.NearestFilter
        this.floor.texture.minFilter = THREE.LinearFilter

        this.floor.material = new THREE.MeshBasicMaterial({
            transparent: true,
            depthWrite: false,
            alphaMap: this.floor.texture,
            opacity: 0,
        })

        this.floor.mesh = new THREE.Mesh(this.geometries.floor, this.floor.material)
        this.floor.mesh.matrixAutoUpdate = false
        this.floor.container.add(this.floor.mesh)
    }

    setInfoArea()
    {
        this.infoArea = this.areas.add({
            position: new THREE.Vector2(this.x, this.y + this.floor.y),
            halfExtents: new THREE.Vector2(3.2, 1.5),
            hasKey: false,
        })

        this.infoArea.on('in', () =>
        {
            gsap.to(this.floor.material, { opacity: 1, duration: 0.35, ease: 'power2.out' })

            // #region agent log
            fetch('http://127.0.0.1:7823/ingest/d35b8971-5abb-4ced-aa93-3de090899b87',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'0ad91f'},body:JSON.stringify({sessionId:'0ad91f',runId:'experience-proximity',location:'Experience.js:setInfoArea',message:'experience info shown',data:{company:this.company,x:this.x,y:this.y},timestamp:Date.now(),hypothesisId:'G'})}).catch(()=>{});
            // #endregion
        })

        this.infoArea.on('out', () =>
        {
            gsap.to(this.floor.material, { opacity: 0, duration: 0.35, ease: 'power2.in' })
        })
    }
}
